/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import { numberFormat, estimate } from 'estimate_list/libs/util'
import {setEstimateItems, setStockLabelLayer} from 'estimate_list/libs/action'
import { gaEvent } from 'estimate_list/libs/gtag'
import AceLink from 'estimate_list/libs/aceLink'
// import {LabelStock} from "../../common/label.style";
import StockLabelComponent from "../../common/stockLabel";
import DefaultTwoButtonLayer from "../layer/defaultTwoButtonLayer";


class Item extends React.Component {
    constructor(props) {
        super(props)
        let count = parseInt(this.props.count, 10)
        let price = parseInt(this.props.itemData.price, 10)
        this.state = {
            item: this.props.itemData,
            count: count,
            price: price,
            displayAlert: { display: 'none' },
            showStockLabelLayer: false,
        }

        this.onClickStockLabel = this.onClickStockLabel.bind(this)
        this.onCloseLayer = this.onCloseLayer.bind(this)
        this.setEstimateDelete = this.setEstimateDelete.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        let count = parseInt(nextProps.count, 10)
        let price = parseInt(nextProps.itemData.price, 10)
        this.setState({ count: count, price: price })
    }

    setEstimateDelete() {
        let estimateItems = ''
        let deleteTargetItemId = String(this.props.itemData.itemID)
        estimateItems = estimate.delEstimateService(deleteTargetItemId, this.props.windowsItemList)

        this.props.setEstimateItems({ estimateItems })
        this.setState({
            displayAlert: { display: 'none' },
        })

        // gaEvent({
        //     type: 'click',
        //     event_category: '상품견적 담기 (취소)',
        //     event_label: `${this.props.itemData.itemID}_${this.props.itemData.itemName}`,
        //     value: 1,
        //     category: `${this.props.itemData.cateID}_${this.props.itemData.cateName}`,
        // })
    }

    setEstimateCount(type) {
        if (this.props.itemData.itemID === 1099785) return false

        let count = this.state.count
        if (type === 'u') {
            count += 1
        } else {
            count -= 1
        }

        // 2022-08-22 수량 1 ~ 99 개 설정 가능하게 수정
        if (count > 0 && count <= 999) {
            estimate.reEstimateItem(this.props.itemData.itemID, count)
            this.props.onChangeCount(this.props.itemData.itemID, type)
            this.setState({ count: count })
        }
    }

    onChangeCount(e) {
        let count = e.target.value

        // 2022-08-22 수량 1 ~ 99 개 설정 가능하게 수정
        if (count > 0 && count <= 999) {
            estimate.reEstimateItem(this.props.itemData.itemID, count)
            this.props.onChangeCount(this.props.itemData.itemID)
            this.setState({ count: count })
        }
    }

    onChecked(e) {
        this.props.onChecked(e.target.checked, this.props.itemData.itemID)
    }

    onDeleteService() {
        this.setState({
            displayAlert: { display: '' },
        })
    }

    onCloseLayer() {
        this.setState({ displayAlert: { display: 'none' }, deleteService: '' })
    }

    onClickStockLabel() {
        this.props.setStockLabelLayer({ showStockLabelLayer : true })
    }

    render() {
        const priceType = typeof this.props.itemData.price
        let price = parseInt(this.props.itemData.price, 10)
        const item = this.props.itemData
        let itemUrl = `${process.env.REACT_APP_SHOPPING_URL}/detail/${item.itemID}`
        let shopId = undefined
        if (window.isMiniShop) {

            let miniShop = this.props?.miniShopInfo
            let miniShopShopNO = miniShop?.shopNO || 1

            itemUrl = itemUrl + '/' + miniShopShopNO
            shopId = miniShopShopNO
        }
        let readOnly = false
        let reaconlyStyle = {
            padding: 0,
            textAlign : 'center'
        }
        if (item.itemID === 1099785 || priceType==='string') {
            readOnly = true
            reaconlyStyle = {
                color: '#999',
                padding: 0,
                textAlign : 'center'
            }
        }


        let titleTag = (
            <AceLink href={itemUrl} target="_blank" className="name" act="item" itemId={item.itemID} shopId={shopId} title={item.fullItemName}>
                <strong >{item.itemName}</strong>
            </AceLink>
        )
        // 2022-08-22 서비스 카테고리 상품은 바로가기 링크 제거 (a tag 제거)
        if (['1011300000'].indexOf(item.cateID.toString()) !== -1) {
            titleTag = (
                <>
                    <strong className="name">{item.itemName}</strong>
                </>
            )
        }

        const buttonTitle = '해당상품을 삭제하시겠습니까?'


        return (
            <tr>
                <td>
                    <span className="icheck">
                        <input
                            type="checkbox"
                            id={'estId-' + item.itemID}
                            name="name-c3"
                            value={item.itemID}
                            checked={this.props.checked}
                            onClick={(e) => this.onChecked(e)}
                            onChange={() => {}}
                        />
                        <label htmlFor={'estId-' + item.itemID}>
                            <span className="ir">선택</span>
                        </label>
                    </span>
                </td>
                <td>
                    <span className="category">{item.cateName}</span>
                </td>
                <td>
                    <div className="box-td">
                        <div className="productname">
                            <StockLabelComponent
                                isShow={item.cnt_firm_b2 && item.cnt_firm_b2 > 0}
                                labelWidth='54'
                                labelHeight='17'
                                labelMargin='0 9px 0 0'
                            />
                            {/*<LabelStock*/}
                            {/*    isShow={item.cnt_firm_b2 && item.cnt_firm_b2 > 0}*/}
                            {/*    onClick={this.onClickStockLabel}*/}
                            {/*    labelWidth='54'*/}
                            {/*    labelHeight='17'*/}
                            {/*    labelMargin='0 9px 0 0'*/}
                            {/*>*/}
                            {/*    재고인증*/}
                            {/*</LabelStock>*/}
                            {titleTag}
                        </div>
                    </div>
                </td>
                <td>
                    {priceType==='number'&&<span className="item_price" >{numberFormat(item.price)}원</span>}
                    {priceType==='string'&&<span className="item_price" style={{fontWeight:'bold',color:'#999999',letterSpacing:'0.18px'}}></span>}
                </td>
                <td>
                    <div className="cnt-change_number">
                        <input
                            type="text"
                            className="istyle"
                            title="개수"
                            value={this.state.count}
                            readOnly={readOnly}
                            onChange={(e) => this.onChangeCount(e)}
                            style={reaconlyStyle}
                            disabled={readOnly}
                            onFocus={(e)=>e.target.select()}
                        />
                        <button type="button" className="icon-angle-up up" onClick={() => this.setEstimateCount('u')} disabled={readOnly}>
                            <em className="ir">추가</em>
                        </button>
                        <button type="button" className="icon-angle-down dn" onClick={() => this.setEstimateCount('d')} disabled={readOnly}>
                            <em className="ir">삭제</em>
                        </button>
                    </div>


                    {this.state.displayAlert.display === '' && (<DefaultTwoButtonLayer
                        title={buttonTitle}
                        onClickLeft={this.onCloseLayer}
                        leftButtonText="취소"
                        onClickRight={this.setEstimateDelete}
                        rightButtonText="삭제"
                        />
                    )}

                </td>
                <td>
                    <strong className="compare_price">
                        {priceType==='number'&&<><span>{numberFormat(this.state.count * price)}</span>원</>}
                        {priceType==='string'&&<span style={{fontWeight:'bold',color:'#999999',letterSpacing:'0.18px'}}>{item.price}</span>}
                    </strong>
                </td>
                <td>
                    <button type="button" className="btn-compare-del" onClick={() => this.onDeleteService()}>
                        <img
                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/btn_compare_del.gif`}
                            alt="삭제"
                        />
                    </button>
                </td>
            </tr>
        )
    }
}

let stateData = (state) => {
    return {
        estimateItems: state.estimateAdd.estimateItems,
        miniShopInfo: state.initial.minishopInfo,
    }
}

let dispatchData = (dispatch) => {
    return {
        setEstimateItems: (estimateItems) => dispatch(setEstimateItems(estimateItems)),
        setStockLabelLayer: (isShow) => dispatch(setStockLabelLayer(isShow)),
    }
}

export default connect(stateData, dispatchData)(Item)



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/item.js